import { useConversionMonitoring } from 'app/components/conversion-monitoring/useConversionMonitoring'
import { ConversionMonitoringComponent } from 'app/components/conversion-monitoring/ConversionMonitoringComponent'

export default function ConversionMonitoringPage() {
  const hookData = useConversionMonitoring()
  return <ConversionMonitoringComponent {...hookData} />
}
